import { SiteModel } from '@modules/site/site-model';

const { fields } = SiteModel;

export default [
  fields.name,
];
